import * as Yup from 'yup';
import { Deadline } from '@models';

export function useValidationSchema() {
  return Yup.object<Deadline>().shape({
    name: Yup.string().nullable().required(),
  });
}
